import { memo } from "react";

// The hologram rings from the approved mockup (design/mockup-stark): three
// rings, a tick bezel every 3 degrees (majors every 30), a slow sweep and two
// counter-rotating arcs. Strokes use currentColor so the threat state can turn
// the whole thing red with one CSS color. viewBox 0 0 560 560, center 280.

const TICKS = (() => {
  const out: Array<{ x1: string; y1: string; x2: string; y2: string; major: boolean }> = [];
  for (let a = 0; a < 360; a += 3) {
    const major = a % 30 === 0;
    const r1 = 250;
    const r2 = major ? 238 : 244;
    const t = (a * Math.PI) / 180;
    out.push({
      x1: (280 + r1 * Math.sin(t)).toFixed(2),
      y1: (280 - r1 * Math.cos(t)).toFixed(2),
      x2: (280 + r2 * Math.sin(t)).toFixed(2),
      y2: (280 - r2 * Math.cos(t)).toFixed(2),
      major,
    });
  }
  return out;
})();

export const RingBase = memo(function RingBase() {
  return (
    <g className="rings">
      <circle cx={280} cy={280} r={250} fill="none" stroke="currentColor" strokeOpacity={0.22} />
      <circle cx={280} cy={280} r={200} fill="none" stroke="currentColor" strokeOpacity={0.1} strokeDasharray="2 6" />
      <circle cx={280} cy={280} r={120} fill="none" stroke="currentColor" strokeOpacity={0.14} />
      {TICKS.map((t, i) => (
        <line key={i} x1={t.x1} y1={t.y1} x2={t.x2} y2={t.y2} stroke="currentColor" strokeOpacity={t.major ? 0.45 : 0.16} strokeWidth={1} />
      ))}
    </g>
  );
});

export function HoloRings({ variant, idPrefix = "holo" }: { variant: "home" | "login" | "threat"; idPrefix?: string }) {
  const grad = `${idPrefix}-sweep`;
  return (
    <svg className="hologram__rings" viewBox="0 0 560 560" aria-hidden="true" focusable="false">
      <RingBase />
      {variant === "login" ? (
        <>
          <g className="spin">
            <path d="M280 30 A250 250 0 0 1 496 155" stroke="currentColor" strokeOpacity={0.8} strokeWidth={1.5} fill="none" />
            <path d="M64 405 A250 250 0 0 1 36 300" stroke="currentColor" strokeOpacity={0.5} strokeWidth={1.5} fill="none" />
          </g>
          <g className="spin rev">
            <path d="M280 110 A170 170 0 0 1 437 215" stroke="currentColor" strokeOpacity={0.35} strokeWidth={1} fill="none" />
            <path d="M180 418 A170 170 0 0 1 125 350" stroke="currentColor" strokeOpacity={0.35} strokeWidth={1} fill="none" />
          </g>
        </>
      ) : (
        <>
          <defs>
            <linearGradient id={grad} x1="0" y1="0" x2="1" y2="0">
              <stop offset="0" stopColor="currentColor" stopOpacity={0} />
              <stop offset="1" stopColor="currentColor" stopOpacity={variant === "threat" ? 0.16 : 0.07} />
            </linearGradient>
          </defs>
          <g className="sweep">
            <path d="M280 280 L280 30 A250 250 0 0 1 405 63 Z" fill={`url(#${grad})`} />
          </g>
          <g className="spin">
            <path d="M280 30 A250 250 0 0 1 480 130" stroke="currentColor" strokeOpacity={0.7} strokeWidth={1.5} fill="none" />
          </g>
          <g className="spin rev">
            <path d="M280 140 A140 140 0 0 1 400 210" stroke="currentColor" strokeOpacity={0.3} strokeWidth={1} fill="none" />
          </g>
        </>
      )}
    </svg>
  );
}
